import { render, staticRenderFns } from "./CompareOther.vue?vue&type=template&id=4adfa842"
import script from "./CompareOther.vue?vue&type=script&lang=js"
export * from "./CompareOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports